import update from 'react-addons-update'
import { SET_JOB} from './action-types'

const initialState = {
  job: {
    label: "ProQuotes"
  }
}

// function nextLetter(s){
//     return s.replace(/([a-zA-Z])[^a-zA-Z]*$/, function(a){
//         var c= a.charCodeAt(0);
//         switch(c){
//             case 90: return 'A';
//             case 122: return 'a';
//             default: return String.fromCharCode(++c)
//         }
//     })
// }

export const financeReducer = (state = initialState, action) => {

  switch (action.type) {

    case SET_JOB:
      return update(state, {job: {$set: action.payload}})


  //
  //   case CHANGE_TAB_NAME:
  //     return update(state, {
  //       sheets: {
  //         [action.payload.sheet]: {
  //           tabs: {
  //             $set: action.payload.arr
  //           }
  //         }
  //       }
  //     })
  //
  //
  //
  // case RESET_SHEET:
  //   return update(state, {sheets: {$set: initialState.sheets}})
  //
  //   case SET_SHEET:
  //     return update(state, {sheets: {$set: action.payload}})
  //
  //   //CHANGE_TAB_NAME
  //
  //   case SET_TAB_DATA:
  //     return update(state, {
  //       sheets: {
  //         [action.payload.sheet]: {
  //           formData: {
  //             $set: action.payload.data
  //           }
  //         }
  //       }
  //     })
  //
  //   case SET_TAB:
  //   // console.log(nextLetter(Object.keys(action.payload.sheet.out.uiSchema)))
  //   // console.log(nextLetter(action.payload.sheet.out.uiSchema))
  //   console.log(action.payload)
  //     const letter = nextLetter(Object.keys(action.payload.sheet.out.uiSchema)[Object.keys(action.payload.sheet.out.uiSchema).length-1])
  //     return update(state, {
  //       sheets: {
  //         [action.payload.sheet]: {
  //           tabs: { $set: action.payload.sheet.out.tabs.concat("New") },
  //           schema: {
  //             properties: {
  //               [letter]: { $set: schemaItem }
  //             }
  //           },
  //           uiSchema: {
  //             [letter]: { $set: schemaUiItem }
  //           }
  //         }
  //       }
  //     })

    default:
      return state;
  }


}



// WEBPACK FOOTER //
// ./src/core/finance/reducer.js